import { PartialStoryFn } from '@storybook/addons';
import { html } from 'lit-html';
import { ifDefined } from 'lit-html/directives/if-defined';
import { SupportingText } from '../supporting-text';

export const meta = {
  argTypes: {
    errorText: { table: { disable: true } },
    helperText: { table: { disable: true } },
  },
  args: {
    errorText: '',
    helperText: '',
  },
  decorators: [
    (story: PartialStoryFn) =>
      html`
        <style type="text/css">
          input {
            border: 1px solid #b5b5b5;
            border-radius: 4px;
            box-sizing: border-box;
            height: 2rem;
            margin: 0.25rem 0;
            padding: 0.5rem;
          }

          label {
            display: block;
          }
        </style>
        <label for="validity-01">For placement only</label>
        <input id="validity-01" type="text" placeholder="For placement only" />
        ${story()}
      `,
  ],
  parameters: {
    controls: {
      hideNoControlsWarning: true,
      sort: 'requiredFirst',
    },
  },
  title: 'Components/Supporting text/',
};

export const story = ({ errorText, helperText }: Partial<SupportingText>) =>
  html`
    <abds-supporting-text
      error-text="${ifDefined(errorText || undefined)}"
      helper-text="${ifDefined(helperText || undefined)}"
    ></abds-supporting-text>
  `;

export default { meta, story };
